import { useKeyDown } from "./useKeyDown";

export function useEnterKeyDown(onKeyDown: (e:any) => void) : (e: React.KeyboardEvent<HTMLInputElement>) => void {
    return useKeyDown('Enter', onKeyDown);
}
